// ProfileCard.js
import React from "react";
import GoogleHotels from "./GoogleHotels";
import Tripadvisor from "./Tripadvisor";
import HolidayCheck from "./HolidayCheck";
// import Share from "./Share";
import Message from "./Message";
import "./ProfileCard.css";

const messages = {
  es: {
    title: "Nos encantaría conocer tu opinión",
    line1: "✨ Gracias por elegir Hotel Condesa ✨",
    line2:
      "Tu opinión es muy valiosa para nosotros. Si disfrutaste tu estancia, ¿nos ayudarías dejando una pequeña reseña? Solo toma un minuto y ayuda a otros viajeros a conocernos mejor.",
    line3: "👇 Elige tu plataforma favorita para dejar tu opinión:",
    disagree: "Si por el contrario, tu estancia no fue como esperabas, por favor envíanos un mensaje detallando qué no salió bien.",
    buttonText: "Mensaje",
    formText: {
      title: "Cuéntanos qué sucedió",
      nameLabel: "Nombre con el que se registró",
      arrivalLabel: "Fecha de llegada",
      departureLabel: "Fecha de salida",
      roomLabel: "Habitación (opcional)",
      messageLabel: "Qué sucedió",
      confirmationLabel: "Los datos son correctos",
      cancelButton: "Cancelar",
      sendButton: "Enviar",
      continueButton: "Continuar",
      backButton: "Atrás",
      confirmTitle: "Enviar mensaje",
      confirmMessage:
        "A continuación se abrirá tu app de correo para enviar el mensaje.",
      dateError:
        "La fecha de salida debe ser igual o posterior a la fecha de llegada.",
    },
  },
  en: {
    title: "We’d love your feedback",
    line1: "✨ Thank you for choosing Hotel Condesa ✨",
    line2:
      "Your opinion means a lot to us. If you enjoyed your stay, would you help us by leaving a short review? It only takes a minute and helps other travelers discover us.",
    line3: "👇 Choose your favorite platform to leave your review:",
    disagree: "If on the other hand, your stay was not as expected, please send us a message detailing what didn't go well.",
    buttonText: "Message",
    formText: {
      title: "Tell us what happened",
      nameLabel: "Name used at check-in",
      arrivalLabel: "Arrival date",
      departureLabel: "Departure date",
      roomLabel: "Room (optional)",
      messageLabel: "What happened",
      confirmationLabel: "The details are correct",
      cancelButton: "Cancel",
      sendButton: "Send",
      continueButton: "Continue",
      backButton: "Back",
      confirmTitle: "Send message",
      confirmMessage:
        "Your email app will now open so you can send the message.",
      dateError:
        "The departure date must be the same as or later than the arrival date.",
    },
  },
  de: {
    title: "Wir freuen uns über Ihre Bewertung",
    line1:
      "✨ Vielen Dank, dass Sie sich für das Hotel Condesa entschieden haben ✨",
    line2:
      "Ihre Meinung ist uns sehr wichtig. Wenn Ihnen Ihr Aufenthalt gefallen hat, würden Sie eine kurze Bewertung hinterlassen? Es dauert nur eine Minute und hilft anderen Reisenden, uns kennenzulernen.",
    line3:
      "👇 Wählen Sie Ihre bevorzugte Plattform, um Ihre Meinung zu hinterlassen:",
    disagree: "Falls Ihr Aufenthalt hingegen nicht Ihren Erwartungen entsprochen hat, senden Sie uns bitte eine Nachricht mit Details darüber, was nicht gut lief.",
    buttonText: "Nachricht",
    formText: {
      title: "Teilen Sie uns mit, was passiert ist",
      nameLabel: "Name beim Check-in",
      arrivalLabel: "Anreisedatum",
      departureLabel: "Abreisedatum",
      roomLabel: "Zimmer (optional)",
      messageLabel: "Was ist passiert?",
      confirmationLabel: "Die Angaben sind korrekt",
      cancelButton: "Abbrechen",
      sendButton: "Senden",
      continueButton: "Weiter",
      backButton: "Zurück",
      confirmTitle: "Nachricht senden",
      confirmMessage:
        "Ihre E-Mail-App wird nun geöffnet, damit Sie die Nachricht senden können.",
      dateError:
        "Das Abreisedatum muss am oder nach dem Anreisedatum liegen.",
    },
  },
  fr: {
    title: "Nous aimerions connaître votre avis",
    line1: "✨ Merci d’avoir choisi l’Hôtel Condesa ✨",
    line2:
      "Votre avis compte beaucoup pour nous. Si vous avez apprécié votre séjour, pourriez-vous laisser un petit commentaire ? Cela ne prend qu’une minute et aide d’autres voyageurs à nous découvrir.",
    line3: "👇 Choisissez votre plateforme préférée pour laisser votre avis :",
    disagree: "Si, au contraire, votre séjour n'a pas répondu à vos attentes, veuillez nous envoyer un message détaillant ce qui n'a pas bien fonctionné.",
    buttonText: "Message",
    formText: {
      title: "Dites-nous ce qui s'est passé",
      nameLabel: "Nom utilisé lors de l'enregistrement",
      arrivalLabel: "Date d'arrivée",
      departureLabel: "Date de départ",
      roomLabel: "Chambre (facultatif)",
      messageLabel: "Ce qui s'est passé",
      confirmationLabel: "Les données sont correctes",
      cancelButton: "Annuler",
      sendButton: "Envoyer",
      continueButton: "Continuer",
      backButton: "Retour",
      confirmTitle: "Envoyer le message",
      confirmMessage:
        "Votre application de messagerie va maintenant s'ouvrir pour envoyer le message.",
      dateError:
        "La date de départ doit être égale ou postérieure à la date d'arrivée.",
    },
  },
  ru: {
    title: "Нам важно ваше мнение",
    line1: "✨ Благодарим за выбор отеля Condesa ✨",
    line2:
      "Ваше мнение очень важно для нас. Если вам понравилось пребывание, оставьте, пожалуйста, небольшой отзыв. Это займет всего минуту и поможет другим путешественникам узнать о нас.",
    line3: "👇 Выберите удобную платформу для отзыва:",
    disagree: "Если, напротив, ваше пребывание не оправдало ожиданий, пожалуйста, пришлите нам сообщение с подробностями того, что пошло не так.",
    buttonText: "Сообщение",
    formText: {
      title: "Расскажите, что произошло",
      nameLabel: "Имя, указанное при регистрации",
      arrivalLabel: "Дата прибытия",
      departureLabel: "Дата выезда",
      roomLabel: "Номер комнаты (необязательно)",
      messageLabel: "Что произошло",
      confirmationLabel: "Данные указаны верно",
      cancelButton: "Отмена",
      sendButton: "Отправить",
      continueButton: "Продолжить",
      backButton: "Назад",
      confirmTitle: "Отправить сообщение",
      confirmMessage:
        "Сейчас откроется ваше почтовое приложение для отправки сообщения.",
      dateError:
        "Дата выезда должна быть такой же или позже даты прибытия.",
    },
  },
};

const ProfileCard = () => {
  // Detectar idioma
  const userLang = navigator.language.slice(0, 2);
  const content = messages[userLang] || messages.en;

  return (
    <div className="container">
      <div className="card-container">
        <div className="image">
          <img src="/images/profile-image.png" alt="Logo Hotel Condesa" />
        </div>
        <div className="descripcion">
          <h2>{content.title}</h2>
          <br />
          <p className="agree">
            <em>{content.line1}</em>
          </p>
          <p className="agree">
            <em>{content.line2}</em>
          </p>
          <p className="agree">
            <em>{content.line3}</em>
          </p>
          <div className="buttons">
            <GoogleHotels />
            <Tripadvisor />
            <HolidayCheck />
          </div>
          <p className="disagree">
            <em>{content.disagree}</em>
          </p>
          <div className="buttons">
            <Message buttonText={content.buttonText} formText={content.formText} />
          </div>
          {/*<Share />*/}
          {/* Footer de marca */}
          <footer className="footer">
            <p
              style={{
                fontSize: "0.75rem",
                color: "#999",
                textAlign: "center",
                marginTop: "2rem",
              }}
            >
              Powered by <strong>Quick Review</strong> ·{" "}
              <a
                href="https://qrev.app"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#999" }}
              >
                qrev.app
              </a>
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
